import { gql } from '@apollo/client'

export const OpenContractChanges = gql`
  query contractChangesByEmployee($id: HashedId!) {
    contractChangesByEmployee(employeeId: $id) {
      id
      validFrom
      changes
      status
      type
    }
  }
`

export const CreateOrUpdateChange = gql`
  mutation createOrUpdateChange($change: ChangeInput!, $employeeId: HashedId!) {
    createOrUpdateChange(change: $change, employeeId: $employeeId) {
      success
      change {
        id
        validFrom
        changes
        status
        type
      }
      error {
        validFrom {
          message
          props
        }
        bonus {
          message
          props
        }
        salary {
          message
          props
        }
        employeeLevel {
          message
          props
        }
        nationalReferenceLevel {
          message
          props
        }
      }
    }
  }
`

export const DeleteChange = gql`
  mutation deleteChange($changeId: HashedId!, $employeeId: HashedId!) {
    deleteChange(changeId: $changeId, employeeId: $employeeId) {
      id
    }
  }
`

export default {
  OpenContractChanges,
  CreateOrUpdateChange,
  DeleteChange,
}
